import { render, staticRenderFns } from "./pIndex.vue?vue&type=template&id=85086bdc"
import script from "./pIndex.vue?vue&type=script&lang=js"
export * from "./pIndex.vue?vue&type=script&lang=js"
import style0 from "./pIndex.vue?vue&type=style&index=0&id=85086bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports